import DeviceManagerLogo from "../assets/images/logo/Device Manager.png";
import AccessManagerLogo from "../assets/images/logo/Access Manager.png";
import AppRegistryLogo from "../assets/images/logo/App Registry.png";
import EVESOpsLogo from "../assets/images/logo/EVES Ops.png";

export const PRODUCT_LOGOS = {
  deviceManager: DeviceManagerLogo,
  accessManager: AccessManagerLogo,
  appRegistry: AppRegistryLogo,
  evesOps: EVESOpsLogo,
} as const;

export const PRODUCT_ACCENT_COLORS: Record<string, string> = {
  DeviceManager: "#55b685",
  Partner: "#3D79F2",
  "XSM-Master": "#7C3AED",
  EvesSysAdmin: "#3762e3",
};
